import { AxiosResponse } from 'axios'

import { manageError, manageResponse } from './api-util'
import { http } from './http'
import { AttachmentProps } from '@/@types/attachment'
import {
  DocumentSearchProps,
  GeneralReportProps,
  ReportFilterProps,
  TestProps,
} from '@/@types/global'
import { Bending } from '@/@types/report/bending'
import { Chemical } from '@/@types/report/chemical'
import { CopperLayer } from '@/@types/report/copperLayer'
import { Ctod } from '@/@types/report/ctod'
import { Flaring } from '@/@types/report/flaring'
import { Flattening } from '@/@types/report/flattening'
import { FourPoint } from '@/@types/report/fourPoint'
import { Hardness } from '@/@types/report/hardness'
import { Hic } from '@/@types/report/hic'
import { Impact } from '@/@types/report/impact'
import { MicroCleanlines } from '@/@types/report/microCleanlines'
import { MicroHardness } from '@/@types/report/microHardness'
import { MicroStructure } from '@/@types/report/microStructure'
import { MicroStructurePhotos } from '@/@types/report/microStructurePhotos'
import { NaceA } from '@/@types/report/naceA'
import { NaceD } from '@/@types/report/naceD'
import { ReportItems } from '@/@types/report/report-items'

const configReport = async (params: any): Promise<any> => {
  try {
    const response: MyResponse<any[]> = await http.post(
      '/config-report',
      params
    )
    return manageResponse(response) as any[]
  } catch (error) {
    manageError(error)
  }
}

const tpiSampleTracking = async (params: any): Promise<any> => {
  try {
    const response: MyResponse<any[]> = await http.post(
      '/tpi-sample-tracking',
      params
    )
    return manageResponse(response) as any[]
  } catch (error) {
    manageError(error)
  }
}

const configApprover = async (params: any): Promise<any> => {
  try {
    const response: MyResponse<any[]> = await http.post(
      '/config-approver',
      params
    )
    return manageResponse(response) as any[]
  } catch (error) {
    manageError(error)
  }
}

const configNotificationUser = async (params: any): Promise<any> => {
  try {
    const response: MyResponse<any[]> = await http.post(
      '/config-notification-user',
      params
    )
    return manageResponse(response) as any[]
  } catch (error) {
    manageError(error)
  }
}

const documentApproval = async (params: any): Promise<any> => {
  try {
    const response: MyResponse<any[]> = await http.post(
      '/document-approval-tpi',
      params
    )
    return manageResponse(response) as any[]
  } catch (error) {
    manageError(error)
  }
}

const document = async (params: any): Promise<any> => {
  try {
    const response: MyResponse<any[]> = await http.post('/document', params)
    return manageResponse(response) as any[]
  } catch (error) {
    manageError(error)
  }
}

const findUserNotifications = async (params: any): Promise<any> => {
  try {
    const response: MyResponse<any[]> = await http.post(
      '/user-notifications',
      params
    )
    return manageResponse(response) as any[]
  } catch (error) {
    manageError(error)
  }
}

const updateUserNotifications = async (params: any): Promise<any> => {
  try {
    const response: MyResponse<any[]> = await http.post('/user-notifications', {
      update: true,
      ...params,
    })
    return manageResponse(response) as any[]
  } catch (error) {
    manageError(error)
  }
}

const listUsers = async (params: any): Promise<any> => {
  try {
    const response: MyResponse<any> = await http.post('/list-users', params)
    if (response && response.data.items && response.items.length > 0) {
      // const currentuser = this.coreService.getConfig().currentUser;
      // if(!currentuser.position || currentuser.position == null){
      // const personnel = result.items.find(item => item.email == currentuser.email);
      // if(personnel){
      //   if(personnel.name && personnel.name != null){
      //     this.userName = personnel.name;
      //   }
      //   if(personnel.position && personnel.position != null){
      //     this.userPosition = personnel.position;
      //   }
      // }
      // }
    }
    return manageResponse(response) as any[]
  } catch (error) {
    manageError(error)
  }
}

const createUser = async (user) => {
  try {
    const response: MyResponse<any> = await http.post('user-create', {
      user,
    })
    return manageResponse(response)
  } catch (error) {
    manageError(error)
  }
}

const getUser = async (params) => {
  try {
    const response: MyResponse<any> = await http.post('user-info', {
      ...params,
    })
    return manageResponse(response)
  } catch (error) {
    manageError(error)
  }
}

const getCollapseCurve = async (params) => {
  try {
    const response: MyResponse<any> = await http.post('collapse-curve', {
      ...params,
    })
    return manageResponse(response)
  } catch (error) {
    manageError(error)
  }
}

const configRemark = async (params) => {
  try {
    const response: MyResponse<any[]> = await http.post('config-remark', params)
    return manageResponse(response) as any[]
  } catch (error) {
    manageError(error)
  }
}

const reportFilter = async (params: ReportFilterProps) => {
  try {
    const response: MyResponse<any[]> = await http.post('/report-filter', {
      ...params,
      decompress: true,
    })
    return manageResponse(response) as any[]
  } catch (error) {
    manageError(error)
  }
}

const documentSearch = async (params: GeneralReportProps) => {
  try {
    const response: MyResponse<any[]> = await http.post('/generate-report', {
      ...params,
    })
    return manageResponse(response) as any[]
  } catch (error) {
    manageError(error)
  }
}

const generateReport = async (params: any) => {
  try {
    const response: MyResponse<any> = await http.post('/generate-report', {
      ...params,
    })
    return manageResponse(response) as any
  } catch (error) {
    manageError(error)
  }
}

const generateReportNew = async (
  test: TestProps,
  selected: ReportItems[]
): Promise<ReportItems[]> => {
  try {
    const response = await http.post('/generate-report-new', {
      test,
      selected,
    })
    const result = manageResponse(response) as { selected?: ReportItems[] }
    return result?.selected ?? []
  } catch (error) {
    manageError(error)
    return []
  }
}

const updateRelease = async (param: any) => {
  try {
    const response = await http.post('/report-document-release', param)
    return manageResponse(response)
  } catch (error) {
    manageError(error)
  }
}

const generateSearchReport = async (params: any): Promise<any> => {
  try {
    const response = await http.post('/generate-report-new', {
      ...params,
    })
    const result = manageResponse(response) as { selected?: ReportItems[] }
    return result?.selected ?? []
  } catch (error) {
    manageError(error)
    return []
  }
}

const sendToFlowApproval = async (params: any) => {
  try {
    const response = await http.post('/send-flow-approval', params)
    return manageResponse(response) as any
  } catch (error) {
    manageError(error)
    return []
  }
}

const usersNotifications = async (params: any) => {
  try {
    const response = await http.post('/users-notifications', params)
    return manageResponse(response) as any
  } catch (error) {
    manageError(error)
    return []
  }
}

const reportNumber = async (params: any) => {
  try {
    const response: MyResponse<any> = await http.post('/report-number', {
      ...params,
    })
    return manageResponse(response) as any
  } catch (error) {
    manageError(error)
  }
}

const createAttachmentOnDatabase = async (attachment: AttachmentProps) => {
  try {
    const response: MyResponse<AttachmentProps> = await http.post(
      'attachment',
      attachment
    )
    return manageResponse(response) as AttachmentProps
  } catch (error) {
    manageError(error)
  }
}

export {
  configRemark,
  reportFilter,
  documentSearch,
  generateReport,
  documentApproval,
  document,
  findUserNotifications,
  updateUserNotifications,
  getUser,
  createAttachmentOnDatabase,
  configReport,
  tpiSampleTracking,
  createUser,
  getCollapseCurve,
  generateReportNew,
  reportNumber,
  sendToFlowApproval,
  usersNotifications,
  generateSearchReport,
  updateRelease,
}
